/**
 * Initialize the sticky CTA behavior.
 */
function initStickyCTA() {
  let dernierePositionDeScrollConnue = 0;
  let ticking = false;
  const CTA = document.querySelector(".mm-main-product-sticky-cta-container");

  if (CTA) {
    const CTA_position = CTA.offsetTop - window.innerHeight / 3;

    /**
     * Add or remove the sticky class to the CTA based on scroll position.
     *
     * @param {number} position_scroll - The current scroll position.
     */
    function toggleStickyCTA(position_scroll) {
      if (position_scroll > CTA_position) {
        CTA.classList.add("mm-cta-sticky");
      } else {
        CTA.classList.remove("mm-cta-sticky");
      }
    }

    window.addEventListener("scroll", () => {
      dernierePositionDeScrollConnue = window.scrollY;

      if (!ticking) {
        ticking = true;

        window.requestAnimationFrame(() => {
          toggleStickyCTA(dernierePositionDeScrollConnue);
          ticking = false;
        });
      }
    });
  }
}

// Class for handling variant selection
class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.cached = {};
    this.container = this.closest(".mm-section-product");
    this.addEventListener("change", this.onVariantChange);
  }

  /**
   * Handle variant change event.
   */
  onVariantChange() {
    this.getSelectedOptions();
    this.getSelectedVariant();

    if (this.currentVariant) {
      this.updateURL();
      this.variantFetch();
      this.updateOptionsStocks();

              // 🟣 MODIF CVE
         const isVariantAvailable = this.currentVariant.available;
         updateStockDisplay(isVariantAvailable);
        // 🟣 FIN
    }
  }

  /**
   * Get selected options from the variant checkboxes.
   */
  getSelectedOptions() {
    this.options = Array.from(
      this.querySelectorAll(".mm-product-variant-checkbox:checked"),
      (checkbox) => checkbox.value
    );
  }

  /**
   * Get variant data from the embedded JSON.
   *
   * @returns {Object} - The variant data.
   */
  getVariantJSON() {
    this.variantData = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );
    return this.variantData;
  }

  /**
   * Get the selected variant based on selected options.
   */
  getSelectedVariant() {
    this.currentVariant = this.getVariantJSON().find((variant) => {
      const findings = !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);

      if (findings) return variant;
    });
  }

  /**
   * Update the URL to include the selected variant ID.
   */
  updateURL() {
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  /**
   * Fetch variant data from the server and cache it.
   */
  variantFetch() {
    var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

    if (this.cached[variantUrl]) {
      this.renderVariantInfo(this.cached[variantUrl]);
      return;
    }

    fetch(variantUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        this.cached[variantUrl] = html;
        this.renderVariantInfo(html);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  /**
   * Render variant information in the DOM.
   *
   * @param {Document} html - The HTML document containing the variant information.
   */
  renderVariantInfo(html) {
    this.updateElementOuter("#product-form-variant-id", html);
    this.updateElementOuter(".mm-product-price", html);
    this.updateElementInner(".mm-product-subtitle", html);
    this.updateElementInner(".mm-product-sticky-cta-subtitle", html);
    this.updateElementClass(".mm-product-cta", html);
    this.updateElementInner(".mm-product-cta .mm-btn-primary", html);
    this.updateElementInner(".mm-main-product-sticky-cta-container", html);
    this.updateElementOuter(".mm-product-form-variant-option>label", html);
    this.updateElementOuter(".mm-product-medias", html);
    this.updateElementOuter("#zoomSplide", html);
    setTimeout(() => {
      startProductMediaSplides();
    }, "500");
  }

  /**
   * Update the inner HTML of an element.
   *
   * @param {string} selector - The CSS selector of the element to update.
   * @param {HTMLElement} html - The HTML element containing the new content.
   */
  updateElement(selector, html) {
    const destination = this.container.querySelector(selector);
    const source = html.querySelector(selector);
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  updateElementClass(selector, html) {
    this.container.querySelector(selector).classList =
      html.querySelector(selector).classList;
  }

  /**
   * Update the outer HTML of an element.
   *
   * @param {string} selector - The CSS selector of the element to update.
   * @param {HTMLElement} html - The HTML element containing the new content.
   */
  updateElementOuter(selector, html) {
    const destinations = this.container.querySelectorAll(selector);
    const sources = html.querySelectorAll(selector);

    if (destinations.length !== sources.length) {
      console.warn(
        "Le nombre d'éléments trouvés ne correspond pas entre les sources et les destinations."
      );
      return;
    }

    destinations.forEach((destination, index) => {
      const source = sources[index];
      if (source && destination) {
        destination.outerHTML = source.outerHTML;
      }
    });
  }
  updateElementInner(selector, html) {
    const destinations = this.container.querySelectorAll(selector);
    const sources = html.querySelectorAll(selector);

    if (destinations.length !== sources.length) {
      console.warn(
        "Le nombre d'éléments trouvés ne correspond pas entre les sources et les destinations."
      );
      return;
    }

    destinations.forEach((destination, index) => {
      const source = sources[index];
      if (source && destination) {
        destination.innerHTML = source.innerHTML;
      }
    });
  }

  updateOptionsStocks() {
    const JSONoptions = this.variantData;
    const optionsValues = document.querySelectorAll(
      ".mm-product-form-variant-values"
    );

    optionsValues.forEach(function (optionValues, index) {
      let mainIndex = index;
      let optionIndex = index;
      let options = optionValues.querySelectorAll("input");

      options.forEach(function (option) {
        let currentOptionTested = option;
        let valuesToTest = [];
        valuesToTest.push(option.value);
        optionsValues.forEach(function (optionValues, index) {
          if (index != optionIndex) {
            let options = optionValues.querySelectorAll("input");
            options.forEach(function (option) {
              if (option.checked) {
                valuesToTest.push(option.value);
              }
            });
          }
          if (index == optionsValues.length - 1) {
            if (checkIfAvailable(JSONoptions, valuesToTest) == false) {
              currentOptionTested.classList.add("mm-disabled");
            } else {
              currentOptionTested.classList.remove("mm-disabled");
            }
          }
        });
      });
    });
  }
}

// Define the custom element
customElements.define("variant-selector", VariantSelector);

function checkIfAvailable(JSONoptions, valuesToTest) {
  const valuesToTestSorted = valuesToTest.slice().sort();

  for (let option of JSONoptions) {
    let optionsSorted = option.options.slice().sort();

    if (
      optionsSorted.every((val, index) => val === valuesToTestSorted[index])
    ) {
      return option.available;
    }
  }

  return false;
}

document.addEventListener("DOMContentLoaded", (event) => {
  var event = new Event("change");
  document.querySelector("variant-selector").dispatchEvent(event);
});

document.addEventListener("DOMContentLoaded", () => {
  initStickyCTA();
});

//Toggle size chart
function mmToggleSizeChart() {
  const sizeChartFilter = document.querySelector(
    ".mm-product-size-chart-filter"
  );
  sizeChartFilter.classList.toggle("mm-active");
}

// Accordeons
function mmAccordeonProduct(clickedElem) {
  const accordeons = document.querySelectorAll(
    ".mm-faq-product-question-header"
  );

  if (clickedElem.classList.contains("mm-active")) {
    clickedElem.classList.remove("mm-active");
  } else {
    accordeons.forEach(function (elem) {
      elem.classList.remove("mm-active");
    });
    clickedElem.classList.add("mm-active");
  }
}

// 🟣 Modifié par Camille VEAUX
function mmAccordeonProductMobile(clickedElem) {
  const accordeons = document.querySelectorAll(
    ".mm-faq-product-question-header"
  );

  if (clickedElem.classList.contains("mm-active")) {
    clickedElem.classList.remove("mm-active");
  } else {
    clickedElem.classList.add("mm-active");
  }
}
// 🟣 FIN

// change qtty
function mmChangeQtty(delta, inputId) {
  var input = document.getElementById(inputId);
  if (delta == "-1" && input.value == "1") {
  } else {
    var newValue = parseInt(input.value, 10) + parseInt(delta, 10);
    input.value = newValue;
  }
}

// 🟣 MODIF CVE
function updateStockDisplay(isAvailable) {
    const offStockDiv = document.getElementById("OffStock");
    const inStockDiv = document.getElementById("InStock");

    if (isAvailable) {
        inStockDiv.style.display = "flex";
        offStockDiv.style.display = "none";
    } else {
        offStockDiv.style.display = "flex";
        inStockDiv.style.display = "none";
    }
}
// 🟣 FIN
